import { mapValues } from 'lodash';
/**
 * Version 24 migration adding admin reg to identity confirmation
 */
export default function v24(website) {
  return {
    ...website,
    eventVersion: 24,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'EventIdentityConfirmation' && !layoutItem.config.adminText) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            adminText: 'EventGuestside_IdentityConfirmation_adminText__resx',
            adminHeaderText: 'EventGuestside_IdentityConfirmation_adminHeaderText__resx',
            adminInstructionalText: {
              htmlContent: 'EventGuestside_IdentityConfirmation_adminInstructionalText__resx',
              editorState: null
            },
            adminFirstNameText: 'EventGuestside_IdentityConfirmation_adminFirstNameText__resx',
            adminLastNameText: 'EventGuestside_IdentityConfirmation_adminLastNameText__resx',
            adminEmailText: 'EventGuestside_IdentityConfirmation_adminEmailText__resx',
            style: {
              ...layoutItem.config.style,
              adminTextStyle: {
                styleMapping: 'body1',
                customSettings: {
                  text: {
                    textAlign: 'left'
                  }
                }
              },
              adminInstructionalTextStyle: {
                styleMapping: 'body1',
                customSettings: {
                  text: {
                    textAlign: 'center'
                  }
                }
              },
              adminHeaderTextStyle: {
                styleMapping: 'header4',
                customSettings: {
                  text: {
                    textAlign: 'center'
                  }
                }
              },
              label: {
                styleMapping: 'label',
                customSettings: {
                  text: {
                    textAlign: 'left'
                  }
                }
              },
              input: {
                styleMapping: 'input',
                customSettings: {
                  text: {
                    textAlign: 'left'
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
